import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  z: () => (/* binding */ IconSustainableInfinnaFiber)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconSustainableInfinnaFiber.tsx


const IconSustainableInfinnaFiber = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-infinna-fiber-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5875, stroke: "#00174F", strokeWidth: 0.825 }), (0,jsx_runtime.jsx)("path", { d: "M11.7586 22.7443C12.0607 22.9576 12.3963 23.0982 12.7559 23.1612L12.9046 22.2982C12.6696 22.2546 12.4538 22.1673 12.2573 22.0267L11.7586 22.7443V22.7443ZM12.497 19.2049C12.7128 19.103 12.9429 19.0497 13.1827 19.0497V18.1721C12.8135 18.1721 12.4586 18.2497 12.1278 18.4097L12.497 19.2049ZM11.5764 20.8776L10.7181 20.9794C10.7613 21.3479 10.8811 21.697 11.0729 22.0121L11.8113 21.5515C11.6867 21.3479 11.61 21.12 11.5812 20.8824L11.5764 20.8776ZM13.5567 22.2788L13.7532 23.1321C14.1033 23.0497 14.4389 22.8849 14.7266 22.657L14.1896 21.9685C14.0026 22.1188 13.7916 22.2255 13.5567 22.2788ZM11.9744 19.5976L11.3271 19.0158C11.0873 19.2873 10.9051 19.617 10.7996 19.9661L11.6291 20.2182C11.6963 19.9903 11.8161 19.777 11.9696 19.5976H11.9744ZM11.4709 15.8497H12.3148V13.2849H13.5663V15.8497H14.4149V12.6933H12.3148V12.6691C12.3148 12.1406 12.5306 11.8885 12.9669 11.8885C13.2594 11.8885 13.4176 12 13.5663 12.257L14.204 12.0097C14.0122 11.6267 13.6813 11.2 12.9333 11.2C12.1278 11.2 11.4709 11.6509 11.4709 12.6352V12.6933H11.0106V13.2897H11.4709V15.8546V15.8497ZM16.0452 14.1576C16.0452 13.6291 16.3137 13.2849 16.7452 13.2849C17.1768 13.2849 17.3542 13.5661 17.3542 14.0509V15.8497H18.2029V13.8812C18.2029 13.1782 17.9008 12.6061 17.0617 12.6061C16.5966 12.6061 16.1986 12.8485 16.0404 13.2073V12.6933H15.1917V15.8497H16.0404V14.1576H16.0452ZM6 15.8497H6.84869V11.4182H6V15.8497ZM9.5242 12.6061C9.05911 12.6061 8.66113 12.8485 8.5029 13.2073V12.6933H7.65422V15.8497H8.5029V14.1576C8.5029 13.6291 8.77141 13.2849 9.20295 13.2849C9.63449 13.2849 9.81189 13.5661 9.81189 14.0509V15.8497H10.6606V13.8812C10.6606 13.1782 10.3585 12.6061 9.51941 12.6061H9.5242ZM14.7026 21.4255L15.3451 21.9927L15.9349 21.3091L15.2924 20.7418L14.7026 21.4255ZM20.0585 18.6279C19.7564 18.4146 19.4207 18.274 19.0611 18.2109L18.9125 19.074C19.1474 19.1176 19.3632 19.2049 19.5598 19.3455L20.0585 18.6279V18.6279ZM25.3328 15.0836V13.823C25.3328 12.994 24.8006 12.6061 23.995 12.6061C23.1895 12.6061 22.6764 13.057 22.571 13.7018L23.3429 13.7746C23.4148 13.4643 23.6066 13.2509 23.9567 13.2509C24.3067 13.2509 24.5033 13.4643 24.5033 13.8182V13.8909L23.645 14.0606C22.9354 14.2061 22.4559 14.4533 22.4559 15.0546C22.4559 15.5976 22.8538 15.9273 23.5059 15.9273C23.9663 15.9273 24.393 15.7333 24.5704 15.3697C24.6471 15.714 24.8725 15.9224 25.2273 15.9224C25.5102 15.9224 25.678 15.8303 25.8171 15.7236V15.263C25.726 15.3067 25.6396 15.3261 25.5533 15.3261C25.4191 15.3261 25.3328 15.2485 25.3328 15.0836ZM24.5033 14.4824C24.5033 14.9915 24.1628 15.3358 23.7169 15.3358C23.4484 15.3358 23.2854 15.2049 23.2854 14.9915C23.2854 14.6764 23.5491 14.6133 23.9135 14.5309L24.5033 14.4V14.4776V14.4824ZM20.7873 12.6061C20.3222 12.6061 19.9242 12.8485 19.766 13.2073V12.6933H18.9173V15.8497H19.766V14.1576C19.766 13.6291 20.0345 13.2849 20.466 13.2849C20.8976 13.2849 21.075 13.5661 21.075 14.0509V15.8497H21.9237V13.8812C21.9237 13.1782 21.6216 12.6061 20.7825 12.6061H20.7873ZM25.8123 12.6933H25.9705V13.0715H26.0712V12.6933H26.2342V12.6061H25.8171V12.6933H25.8123ZM26.6609 12.6061L26.5603 12.9455L26.4644 12.6061H26.3109V13.0715H26.402V12.703L26.5171 13.0715H26.5938L26.7041 12.703V13.0715H26.8V12.6061H26.6562H26.6609ZM20.0057 19.8255C20.1304 20.0291 20.2071 20.257 20.2359 20.4946L21.0941 20.3927C21.051 20.0243 20.9311 19.6752 20.7393 19.36L20.0009 19.8206L20.0057 19.8255ZM18.6296 22.3224V23.2C18.9988 23.2 19.3536 23.1224 19.6845 22.9624L19.3153 22.1673C19.0995 22.2691 18.8693 22.3224 18.6296 22.3224ZM17.0857 18.7152L17.6227 19.4036C17.8097 19.2533 18.0207 19.1467 18.2556 19.0933L18.059 18.24C17.709 18.3224 17.3734 18.4873 17.0857 18.7152ZM19.8379 21.7746L20.4852 22.3564C20.7249 22.0849 20.9071 21.7552 21.0126 21.4061L20.1831 21.154C20.116 21.3818 19.9961 21.5952 19.8427 21.7746H19.8379ZM15.8774 20.063L16.5199 20.6303L17.1096 19.9467L16.4671 19.3794L15.8774 20.063Z", fill: "#00174F" })] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-infinna-fiber-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5875, stroke: "#00174F", strokeWidth: 0.825 }), (0,jsx_runtime.jsx)("path", { d: "M11.7586 22.7443C12.0607 22.9576 12.3963 23.0982 12.7559 23.1612L12.9046 22.2982C12.6696 22.2546 12.4538 22.1673 12.2573 22.0267L11.7586 22.7443V22.7443ZM12.497 19.2049C12.7128 19.103 12.9429 19.0497 13.1827 19.0497V18.1721C12.8135 18.1721 12.4586 18.2497 12.1278 18.4097L12.497 19.2049ZM11.5764 20.8776L10.7181 20.9794C10.7613 21.3479 10.8811 21.697 11.0729 22.0121L11.8113 21.5515C11.6867 21.3479 11.61 21.12 11.5812 20.8824L11.5764 20.8776ZM13.5567 22.2788L13.7532 23.1321C14.1033 23.0497 14.4389 22.8849 14.7266 22.657L14.1896 21.9685C14.0026 22.1188 13.7916 22.2255 13.5567 22.2788ZM11.9744 19.5976L11.3271 19.0158C11.0873 19.2873 10.9051 19.617 10.7996 19.9661L11.6291 20.2182C11.6963 19.9903 11.8161 19.777 11.9696 19.5976H11.9744ZM11.4709 15.8497H12.3148V13.2849H13.5663V15.8497H14.4149V12.6933H12.3148V12.6691C12.3148 12.1406 12.5306 11.8885 12.9669 11.8885C13.2594 11.8885 13.4176 12 13.5663 12.257L14.204 12.0097C14.0122 11.6267 13.6813 11.2 12.9333 11.2C12.1278 11.2 11.4709 11.6509 11.4709 12.6352V12.6933H11.0106V13.2897H11.4709V15.8546V15.8497ZM16.0452 14.1576C16.0452 13.6291 16.3137 13.2849 16.7452 13.2849C17.1768 13.2849 17.3542 13.5661 17.3542 14.0509V15.8497H18.2029V13.8812C18.2029 13.1782 17.9008 12.6061 17.0617 12.6061C16.5966 12.6061 16.1986 12.8485 16.0404 13.2073V12.6933H15.1917V15.8497H16.0404V14.1576H16.0452ZM6 15.8497H6.84869V11.4182H6V15.8497ZM9.5242 12.6061C9.05911 12.6061 8.66113 12.8485 8.5029 13.2073V12.6933H7.65422V15.8497H8.5029V14.1576C8.5029 13.6291 8.77141 13.2849 9.20295 13.2849C9.63449 13.2849 9.81189 13.5661 9.81189 14.0509V15.8497H10.6606V13.8812C10.6606 13.1782 10.3585 12.6061 9.51941 12.6061H9.5242ZM14.7026 21.4255L15.3451 21.9927L15.9349 21.3091L15.2924 20.7418L14.7026 21.4255ZM20.0585 18.6279C19.7564 18.4146 19.4207 18.274 19.0611 18.2109L18.9125 19.074C19.1474 19.1176 19.3632 19.2049 19.5598 19.3455L20.0585 18.6279V18.6279ZM25.3328 15.0836V13.823C25.3328 12.994 24.8006 12.6061 23.995 12.6061C23.1895 12.6061 22.6764 13.057 22.571 13.7018L23.3429 13.7746C23.4148 13.4643 23.6066 13.2509 23.9567 13.2509C24.3067 13.2509 24.5033 13.4643 24.5033 13.8182V13.8909L23.645 14.0606C22.9354 14.2061 22.4559 14.4533 22.4559 15.0546C22.4559 15.5976 22.8538 15.9273 23.5059 15.9273C23.9663 15.9273 24.393 15.7333 24.5704 15.3697C24.6471 15.714 24.8725 15.9224 25.2273 15.9224C25.5102 15.9224 25.678 15.8303 25.8171 15.7236V15.263C25.726 15.3067 25.6396 15.3261 25.5533 15.3261C25.4191 15.3261 25.3328 15.2485 25.3328 15.0836ZM24.5033 14.4824C24.5033 14.9915 24.1628 15.3358 23.7169 15.3358C23.4484 15.3358 23.2854 15.2049 23.2854 14.9915C23.2854 14.6764 23.5491 14.6133 23.9135 14.5309L24.5033 14.4V14.4776V14.4824ZM20.7873 12.6061C20.3222 12.6061 19.9242 12.8485 19.766 13.2073V12.6933H18.9173V15.8497H19.766V14.1576C19.766 13.6291 20.0345 13.2849 20.466 13.2849C20.8976 13.2849 21.075 13.5661 21.075 14.0509V15.8497H21.9237V13.8812C21.9237 13.1782 21.6216 12.6061 20.7825 12.6061H20.7873ZM25.8123 12.6933H25.9705V13.0715H26.0712V12.6933H26.2342V12.6061H25.8171V12.6933H25.8123ZM26.6609 12.6061L26.5603 12.9455L26.4644 12.6061H26.3109V13.0715H26.402V12.703L26.5171 13.0715H26.5938L26.7041 12.703V13.0715H26.8V12.6061H26.6562H26.6609ZM20.0057 19.8255C20.1304 20.0291 20.2071 20.257 20.2359 20.4946L21.0941 20.3927C21.051 20.0243 20.9311 19.6752 20.7393 19.36L20.0009 19.8206L20.0057 19.8255ZM18.6296 22.3224V23.2C18.9988 23.2 19.3536 23.1224 19.6845 22.9624L19.3153 22.1673C19.0995 22.2691 18.8693 22.3224 18.6296 22.3224ZM17.0857 18.7152L17.6227 19.4036C17.8097 19.2533 18.0207 19.1467 18.2556 19.0933L18.059 18.24C17.709 18.3224 17.3734 18.4873 17.0857 18.7152ZM19.8379 21.7746L20.4852 22.3564C20.7249 22.0849 20.9071 21.7552 21.0126 21.4061L20.1831 21.154C20.116 21.3818 19.9961 21.5952 19.8427 21.7746H19.8379ZM15.8774 20.063L16.5199 20.6303L17.1096 19.9467L16.4671 19.3794L15.8774 20.063Z", fill: "#00174F" })] })));
};

})();

var __webpack_exports__IconSustainableInfinnaFiber = __webpack_exports__.z;
export { __webpack_exports__IconSustainableInfinnaFiber as IconSustainableInfinnaFiber };
